<template>
  <div id="NotFound">
      <h1>Error 404</h1>
      <p>{{ this.$router.currentRoute.path }}</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style lang="scss">
#NotFound {}
</style>
